import { useTranslation } from 'react-i18next';
import { LegalPageLayout } from '../components/layout/LegalPageLayout';
import { LegalContent } from '../components/legal/LegalContent';
import { LEGAL_NOTICE_CONTENT } from '../content/legalNotice';

export const LegalNoticePage = () => {
  const { t } = useTranslation();

  return (
    <LegalPageLayout title={t('legal.notice.title')}>
      <LegalContent sections={LEGAL_NOTICE_CONTENT} />
    </LegalPageLayout>
  );
};
